export interface PainPoint {
  title: string
  description: string
}

export const painPoints: PainPoint[] = [
  {
    title: 'Ore su mappe mute e schede sparse trovate online',
    description:
      'Ti ritrovi con materiale bello ma scollegato: fatica a dare continuità tra un argomento e l’altro.',
  },
  {
    title: 'Improvvisare all’ultimo minuto',
    description:
      'Quando manca il tempo, finisci per scegliere attività generiche che non allenano davvero l’orientamento o la lettura del territorio.',
  },
  {
    title: 'Sentirsi poco sicuri con la geografia politica o fisica',
    description:
      'Domande sui confini, sui continenti o sui dati del territorio che non sai sempre come affrontare con sicurezza.',
  },
  {
    title: 'Materiali e mappe da cercare, stampare e organizzare ogni volta',
    description: 'Con GEOGRAFIA PRONTA™ riduci al minimo la logistica: tutto è già pronto e coerente.',
  },
]
